export const enum SoundVolume {
    MAIN_THEME = 0.3,
    MAIN_WIN_THEME = 0.3,
    FS_THEME = 0.3,

    SYMBOL_POP = 1,
    LP_WIN = 1,
    HP_WIN = 1,
    WILD_WIN = 1,

    SCATTER_LAND = 1,
    SCATTER_TRIGGER = 1,

    REEL_START = 1,
    REEL_SPIN = 1,
    REEL_STOP = 1,

    INTRO_SOUND = 1,
    INTRO_TRANSITION_SOUND = 1,

    BIG_WIN_TRIGGER = 1,
    BIG_WIN_END = 0.5,
    BIG_WIN_THEME = 0.5,
    BIG_WIN_COUNT_UP = 1,

    APPEAR_POPUP = 1,
    DISAPPEAR_POPUP = 1,
    UI_BUTTONS = 1,

    MULTIPLIER_LAND = 1,
    MULTIPLIER_COLLECT = 1,
    MULTIPLIER_JAR = 1,
    MULTIPLIER_TRAIL = 1,

    SYMBOLS_DROP = 1,
}
